import { render } from "./StageFoyer.vue?vue&type=template&id=15e0c182"
import script from "./StageFoyer.vue?vue&type=script&lang=js"
export * from "./StageFoyer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vote.gikit.ru/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__